import * as React from 'react';

export const CUSTOM_SCROLL_CSS = ` <style>
/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  border: solid 1px rgba(255, 255, 255, 0.25);
  background-color: rgba(0, 0, 0, 0.25);
  transition: background-color 300ms ease-in-out;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
  transition: background-color 300ms ease-in-out;
}
// Scrollbars for FF
:root {
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
  scrollbar-width: thin !important;
}
body{
    min-width:300px;
  }
</style>`;

type TransformHtmlViewerProps = {
    value: string
}

export function TransformHtmlViewer({ value }: TransformHtmlViewerProps) {
    return <iframe
        title="preview-frame"
        width="100%"
        height="100%"
        srcDoc={`
        ${CUSTOM_SCROLL_CSS}
        ${value}
        `}
    />;
}
